// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the calculator component for Stamp Duty calculations
import StampDutyCalculator from "../../frontend/components/calculators/StampDutyCalculator";

// Main page component for the Stamp Duty calculator
const StampDutyPage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero title="Stamp Duty" subtitle="" backgroundImage={CalculatorsImag1} />
      {/* Render the Stamp Duty Calculator */}
      <StampDutyCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default StampDutyPage;
